module.exports = __webpack_public_path__ + "img/report.832f9bc9.png";